import { render, staticRenderFns } from "./Stepper.vue?vue&type=template&id=055d38cf&scoped=true"
import script from "./Stepper.vue?vue&type=script&lang=js"
export * from "./Stepper.vue?vue&type=script&lang=js"
import style0 from "./Stepper.vue?vue&type=style&index=0&id=055d38cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d38cf",
  null
  
)

export default component.exports